

























































































import { Component, Mixins, Ref } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
  },
})
export default class BusinessCreateGeneral extends Mixins(CRUDMixins) {
  @Ref() readonly businessGeneralForm!: { setErrors: (any?: any) => void };

  tmpBusiness = {};

  isLoading = false;

  isCreated = false;

  newBusinessObjectId = null;

  create() {
    this.isLoading = true;
    this.$store
      .dispatch('Business/create', this.tmpBusiness)
      .then(async (response) => {
        if (response.data.data) {
          this.newBusinessObjectId = response.data.data.object_id;
        }
        await this.$store.dispatch('Auth/fetchUser');
        this.isLoading = false;
        this.isCreated = true;
      })
      .catch(({ response }) => {
        this.isLoading = false;
        this.businessGeneralForm.setErrors(response.data.error);
      });
  }

  goToDashboard() {
    this.isCreated = false;
    this.$router.push({
      name: 'business-dashboard',
    });
  }

  switchToNewBusiness() {
    this.$store.commit('Auth/SET_ACTIVE_BUSINESS', this.newBusinessObjectId);
    this.goToDashboard();
  }
}
